import { __assign } from "tslib";
import * as React from 'react';
import { default as MuiTableCell } from '@material-ui/core/TableCell';
export var TableCell = React.forwardRef(function (props, ref) { return (React.createElement(MuiTableCell, __assign({ ref: ref }, props))); });
export default TableCell;
//# sourceMappingURL=TableCell.js.map